import { Link } from "@tanstack/react-router";
import type { SubmissionBrief } from "@/app/reviewQueries";
import { StatusChip } from "@/ui/StatusChip";
import { STATUS, fmtDate, isLate, replyLabel, sortSubmissions, submissionsHint } from "./model";

const HEAD = ["задание", "отправлено", "итерация", "ответ", "статус", ""];

/** Таблица сдач студента (M3 «сдачи»): статусы по палитре CLAUDE.md — на проверке
 *  жёлтым (макет красил красным — расхождение, не повторяем). */
export function Submissions({ subs, now }: { subs: SubmissionBrief[]; now: number }) {
  const rows = sortSubmissions(subs);
  return (
    <section data-testid="submissions">
      <div className="mb-3 flex flex-wrap items-baseline gap-3">
        <h2 className="m-0 font-mono text-[16px] font-bold tracking-[-.01em]">Сдачи</h2>
        <span className="font-mono text-[11.5px] text-mut" data-testid="submissions-hint">
          {submissionsHint(subs)}
        </span>
      </div>
      {rows.length === 0 ? (
        <p className="m-0 rounded-md border border-dashed border-bd px-4 py-5 font-mono text-[12.5px] text-mut" data-testid="submissions-empty">
          Сдач ещё нет — студент не отправлял домашки на проверку. Первая появится здесь и в очереди.
        </p>
      ) : (
        <table className="w-full border-collapse overflow-hidden rounded-md border border-bd">
          <thead>
            <tr className="bg-bg2">
              {HEAD.map((h, i) => (
                <th key={i} scope="col" className="px-3 py-2.5 text-left font-mono text-[10.5px] font-normal uppercase tracking-[.06em] text-mut">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((s) => {
              const late = isLate(s, now);
              return (
                <tr key={s.id} data-testid="submission-row" data-status={s.status} className="border-t border-bd align-top">
                  <td className="px-3 py-3">
                    <span className="block font-mono text-[12px] text-ink">{s.assignment}</span>
                    {s.summary && <span className="mt-1 block text-[12px] leading-[1.45] text-ink2">{s.summary}</span>}
                  </td>
                  <td className="px-3 py-3 font-mono text-[12px] text-ink2">{fmtDate(s.submitted_at)}</td>
                  <td className="px-3 py-3 font-mono text-[12px] text-mut">v{s.iteration}</td>
                  <td className={`px-3 py-3 font-mono text-[12px] ${late ? "text-err" : "text-ink2"}`} data-testid="submission-reply">
                    {replyLabel(s, now)}
                    {late && <span className="block text-[10.5px]">за пределами SLA</span>}
                  </td>
                  <td className="px-3 py-3">
                    <StatusChip status={STATUS[s.status]} compact />
                  </td>
                  <td className="px-3 py-3 text-right">
                    <Link to="/mentor/review/$submissionId" params={{ submissionId: s.id }} className="font-mono text-[11.5px] text-acc no-underline hover:underline">
                      {s.status === "on_review" ? "открыть ревью" : "открыть"}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </section>
  );
}
